module.exports = __webpack_public_path__ + "img/logo2.3cda9a85.png";